import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    step: 0,
    min_premium_p: 0,
    min_premium_l: 0,
    count_offer_property: 0,
    count_offer_life: 0
};

export const formSlice = createSlice({
    name: 'form',
    initialState,
    reducers: {
        nextStep: (state) => {
            state.step = state.step + 1;
        },
        setStep: (state, action) => {
            state.step = action.payload
        },
        setMinPremiumP: (state, action) => {
            state.min_premium_p = action.payload
        },
        setMinPremiumL: (state, action) => {
            state.min_premium_l = action.payload
        },
        setCountOfferP: (state, action) => {
            state.count_offer_property = action.payload
        },
        setCountOfferL: (state, action) => {
            state.count_offer_life = action.payload
        }
    },
});

export const { 
    setStep,
    nextStep,
    setMinPremiumP,
    setMinPremiumL,
    setCountOfferP,
    setCountOfferL
} = formSlice.actions;

export const getCurrentStep = (state) => {
    return state.form.step
};

export const selectMinPremiumP = (state) => state.form.min_premium_p;
export const selectMinPremiumL = (state) => state.form.min_premium_l;
export const selectCountOfferP = (state) => state.form.count_offer_property;
export const selectCountOfferL = (state) => state.form.count_offer_life;

export default formSlice.reducer;
